import {createRouter,createWebHashHistory} from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(),
  routes:[{
    path: '/basic',
    name: 'basic',
    component: () => import('@/pages/mapBasic/index.vue'),
  },{
    path: '/advance',
    name: 'advance',
    component: () => import('@/pages/mapAdvance/index.vue'),
  },{
    path: '/',
    redirect: '/basic'
  }]
});

export default router